import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

export const EditGamePageTable = ({ gameToEdit }) => {

    const [stadium, setStadium] = useState(gameToEdit.stadium);
    const [bravesScore, setBravesScore] = useState(gameToEdit.bravesScore);
    const [date, setDate] = useState(gameToEdit.date);

    const redirect = useNavigate();

    const editGame = async () => {
        const response = await fetch(`/games/${gameToEdit._id}`, {
            method: 'PUT',
            body: JSON.stringify({
                stadium: stadium,
                bravesScore: bravesScore,
                date: date
            }),
            headers: { 'Content-Type': 'application/json', },
        });

        if (response.status === 200) {
            alert("Game successfully edited!");
        } else {
            const errMessage = await response.json();
            alert(`Error editing game. Server responded with status code ${response.status}. ${errMessage.Error}`);
        }

        redirect("/");
    }

    return (
        <>
            <article>
                <h2>Edit a game</h2>
                <p><p>On this page, you can edit the details of an existing game. Modify the stadium,
                    Braves' score, or date of the game and click "Edit" to save the changes.</p>
                </p>
                <table id="games">
                    <thead>
                        <tr>
                            <th>Game Stadium</th>
                            <th>Braves Score</th>
                            <th>Date of the Game</th>
                            <th>Submit Changes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input type="text" placeholder="Enter the Stadium..." value={stadium} onChange={e => setStadium(e.target.value)} id="stadium" />
                            </td>
                            <td>
                                <input type="number" value={bravesScore} placeholder="Enter Braves Score..." onChange={e => setBravesScore(e.target.value)} id="bravesScore" />
                            </td>
                            <td>
                                <input type="date" value={date} onChange={e => setDate(e.target.value)} id="date" />
                            </td>
                            <td>
                                <button type="submit" onClick={editGame} id="submit">Edit</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </article>
        </>
    );
}

export default EditGamePageTable;